var _excluded = ["color", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import '../style/index.less';

function SvgGdprColored(_ref) {
  var color = _ref.color,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded);

  var props = _objectSpread({
    color: color,
    className: classNames('zbanx-icon-svg', className)
  }, other);

  return /*#__PURE__*/React.createElement("svg", _objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M173.32,63.2,160.8,69.018v8.727c0,8.071,5.333,15.6,12.52,17.454,7.187-1.825,12.52-9.383,12.52-17.454V69.018Z",
    transform: "translate(-157.755 -63.2)",
    fill: "#5b8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(6 6)",
    fill: "#1750b8",
    d: "M9.5 0A9.5 9.5 0 1 0 9.5 19A9.5 9.5 0 1 0 9.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19457.488,17215.607c1.17-2.148,4.316-3.689,8.012-3.689s6.842,1.541,8.012,3.689a9.5,9.5,0,0,1-16.023,0Zm4.043-9.227a3.97,3.97,0,1,1,3.969,3.875A3.925,3.925,0,0,1,19461.531,17206.381Z",
    transform: "translate(-19450 -17195)",
    fill: "#fff"
  }));
}

SvgGdprColored.defaultProps = {
  color: 'inherit'
};
export default SvgGdprColored;